import { render, staticRenderFns } from "./ContractNpsChip.vue?vue&type=template&id=2e458628&scoped=true&"
import script from "./ContractNpsChip.vue?vue&type=script&lang=js&"
export * from "./ContractNpsChip.vue?vue&type=script&lang=js&"
import style0 from "./ContractNpsChip.vue?vue&type=style&index=0&id=2e458628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e458628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
